<template>
    <div class="cardPay">
        <el-steps class="registerWrapper" :active="active" :rules="rules" align-center>
            <el-step title="确认订单" class="cursorSz" description="">
            </el-step>
            <el-step title="支付" class="cursorSz" description="">
            </el-step>
            <el-step title="完成" class="cursorSz" description="">
            </el-step>
        </el-steps>
        <div class="border position-relative commonBackground padding-x padding-y margin-medium-top">
            <div class="position-relative">
                <div class="commonLeftTip ">个人信息</div>
            </div>
            <el-form ref="formName" style="width:431px;" :model="userInfo" label-width="110px"
                     label-position="left"
                     class="formColumn m-auto commonBackground padding-medium" :rules="rules">
                <el-form-item label="姓名" prop="realName">
                    <el-input v-model="userInfo.realName" size="medium" placeholder="请输入姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="phone" v-show="productData.needBindMobile">
                    <el-input v-model="userInfo.phone" size="medium" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="smsCode" v-show="productData.needBindMobile">
                    <el-input v-model="userInfo.smsCode" size="medium" placeholder="请输入验证码" style="width: 130px;"></el-input>
                    <el-button v-show="timeSmsCode===0" size="medium" type="success" @click="tapSmscode" class="float-right">发送验证码</el-button>
                    <el-button v-show="timeSmsCode>0" type="success" size="medium" class="float-right">{{timeSmsCode+'s'}}</el-button>
                </el-form-item>

                <el-form-item label="高考所在省份" prop="provinceId">
                    <el-select v-model="userInfo.provinceId" size="medium" placeholder="选择省份">
                        <el-option
                                v-for="item in provinceList"
                                :key="item.provinceId"
                                :label="item.provinceName"
                                :value="item.provinceId">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="border position-relative padding-x padding-y margin-medium-top">
            <el-table :data="tableData" :border="true" :cell-style="{textAlign:'center'}" :header-cell-style="{textAlign:'center',background:'#6ac0e8',color:'#ffffff',fontSize:'1.2em'}">
                <el-table-column label="名称" prop="title">
                </el-table-column>
                <el-table-column label="有效期" prop="expireTime">
                </el-table-column>
                <el-table-column label="价格" prop="salePrice">
                </el-table-column>
            </el-table>
        </div>
        <el-divider></el-divider>
        <div class="bottomPay text-right">
            <span class="titleP text-default-color">应付金额</span> <span class="price">{{'￥'+productData.salePrice}}</span>
            <el-button class="margin-left" @click="submitOrder" style="background:deepskyblue;border: 1px solid deepskyblue;color: #ffffff;">
                提交订单
            </el-button>
        </div>
    </div>
</template>

<script>
    import {bindPhone, cardBuyOrderPerson, cardBuyProvinceList, cardBuySubmitOrder} from "../../../config";
    import {message} from 'element-ui'
    export default {
        name: "cardPay",
        data(){
            var checkName=(rule,value,callback)=>{
                let nameZz= /^[a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
                if(!value){
                    return callback(new Error('姓名不能为空'));
                }else if(!nameZz.test(value)){
                    return callback(new Error('姓名格式不正确'))
                }else{
                    callback();
                }
            };
           var postM=(rule,value,callback)=>{

                if(!value){
                    return callback(new Error('验证码为空'));
                }else{
                    callback();
                }
            };
            var checkPhone=(rule,value,callback)=>{
                let nameZz= /^1[0-9]{10}$/;
                if(!value&&this.productData.needBindMobile){
                    return callback(new Error('手机号不能为空'));
                }else if(!nameZz.test(value)&&this.productData.needBindMobile){
                    return callback(new Error('手机号格式不正确'))
                }else{
                    callback();
                }
            };
            return{
                timeSzhi:'',
                timeSmsCode:0,
                provinceList:[],
                rules:{
                    // smsCode:[
                    //     {required:true,validator:postM,trigger:'blur'}
                    // ],
                    realName:[
                        {required:true,validator:checkName,trigger:'blur'}
                    ],
                    provinceId:[
                        {required:true,message:'未选择省份',trigger:'blur'}
                    ],
                    // phone:[
                    //     {required:true,validator:checkPhone,trigger:'blur'}
                    // ]
                },
                active:1,
                userInfo:{
                    realName:'',
                    provinceId:'',
                    phone:'',
                    smsCode:''
                },
                productData:{},
                tableData:[],
                bindPhone:false
            }
        },
        mounted() {
            if(this.$route.query.productId){
                this.loadSearchContent();
                this.searchProvinceInfo();
            }else{
                message({
                    message:'非正常进入无法获得订单信息',
                    offset:300,
                    type:'warning'
                })
                this.$router.push('/login/cardBuy');
            }
        },
        beforeDestroy(){
          clearTimeout(this.timeSzhi);
        },
        methods:{
            //发送验证码
            async tapSmscode(){
                let result=await bindPhone(this.userInfo.phone);
                if(result.status){
                    this.timeSmsCode=60;
                    let xss=(()=>{
                        this.timeSzhi=setTimeout(()=>{
                            if(this.timeSmsCode>0){
                                this.timeSmsCode-=1;
                                xss();
                            }else{
                                clearTimeout(this.timeSzhi);
                            }
                        },1000)
                    });
                    xss();
                }
            },
            //提交订单
            submitOrder(){
                this.$refs['formName'].validate(async (valid)=>{
                    console.log(valid);
                    if(valid){
                        if(this.productData.needBindMobile&&this.userInfo.phone===''){
                            message({
                                message:"未输入手机号",
                                duration:800,
                                type:"warning"
                            })
                            return false;
                        }
                        if(this.productData.needBindMobile&&this.userInfo.smsCode===''){
                            message({
                                message:"未输入验证码",
                                duration:800,
                                type:"warning"
                            })
                            return false;
                        }
                        let result=await cardBuySubmitOrder(this.userInfo.realName,this.userInfo.provinceId,this.productData.needBindMobile,this.productData.productId,this.userInfo.phone,this.userInfo.smsCode);
                        console.log(result);
                        if(result.status){
                            console.log(result.data);
                            this.$router.push({path:'/login/cardBeginPay',query:{order:JSON.stringify(result.data)}})
                        }
                    }
                })
            },
            //查出省份信息
            async searchProvinceInfo(){
                let result=await cardBuyProvinceList();
                if(result.status){
                    this.provinceList=result.data;
                    console.log(result.data);
                }else{
                }
            },
            //加载查出订单相关内容
            async loadSearchContent(){
                this.tableData=[];
                let result=await cardBuyOrderPerson(this.$route.query.productId);
                if(result.status) {
                    this.productData=result.data;
                    this.tableData.push(result.data);
                }
            }
        }
    }
</script>
<style lang="scss">
    .cardPay{
         .el-form-item__content{
             width: 307px;
         }
        .el-select{
            width:100%;
        }
    }
</style>
<style lang="scss" scoped>
    .cardPay{
        width: 1000px;
        margin: 30px auto 30px auto;
        .commonLeftTip{
            font-size: 1.2em;
            font-weight: 600;
            margin:0 0 20px 10px;
        }

        .bottomPay{

            .titleP{
                font-size: 1.1em;
            }
            .price{
                color: orangered;
                font-size: 1.3em;
                font-weight: bolder;
            }
        }
    }
</style>